<template>
    <el-drawer :modal="false" 
        title="Products"
        :visible.sync="drawerSolutionScenario"
        class="drawer-solution-scenario"
        size="60%"
    >
        <b-container>
            <div v-show="layoutProps.showCalculatePage">
                <CalculateSolutionScenario :commitments="commitments" :tables="tables" :product_details="product_details"/>
            </div>
            
            <div v-show="layoutProps.showSelectSolutionStepsPage">
                <PropertySelectionSolutionSteps v-bind="showsProps" />
            </div>

            <div v-show="layoutProps.showPersonalSolutionStepsPage">
                <PersonalLoanSolutionSteps v-bind="showsProps" />
            </div>

            <div v-show="layoutProps.showMortgageSolutionStepsPage">
                <MortgageSolutionSteps v-bind="showsProps" />
            </div>

            <div v-show="layoutProps.showInsuranceSolutionStepsPage">
                <InsuranceSolutionSteps v-bind="showsProps" />
            </div>

            <div v-show="layoutProps.showRefinancingSolutionStepsPage">
                <RefinancingSolutionSteps v-bind="showsProps" />
            </div>

            <div v-show="layoutProps.showOtherLoanSolutionStepsPage">
                <OtherLoanSolutionSteps v-bind="showsProps" />
            </div>

            <div v-show="layoutProps.showSolicitorSolutionStepsPage">
							<SolicitorSolutionSteps v-bind="showsProps" />
            </div>

						<div v-show="layoutProps.showMhlvSolutionStepsPage">
								<MhlvSolutionSteps v-bind="showsProps" />
						</div>
        </b-container>
    </el-drawer>
</template>
<script>
import { Drawer } from 'element-ui'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import CalculateSolutionScenario from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/CalculateSolutionScenario'
import PropertySelectionSolutionSteps from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PropertySolution/SelectionSolutionSteps'
import PersonalLoanSolutionSteps from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PersonalLoan/PersonalLoanSolutionSteps'
import MortgageSolutionSteps from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/MortgageSolution/MortgageSolutionSteps'
import InsuranceSolutionSteps from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/InsuranceSolution/InsuranceSolutionSteps'
import RefinancingSolutionSteps from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/RefinancingSolution/RefinancingSolutionSteps'
import SolicitorSolutionSteps from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/SolicitorSolution/SolicitorSolutionSteps'

import OtherLoanSolutionSteps from './OtherLoanSolution/OtherLoanSolutionSteps.vue'
import MhlvSolutionSteps from './MhlvSolution/MhlvSolutionSteps.vue'

export default {
    props:['commitments', 'product_details'],
    components: {
    CalculateSolutionScenario,
    PropertySelectionSolutionSteps,
    PersonalLoanSolutionSteps,
    MortgageSolutionSteps,
    InsuranceSolutionSteps,
    RefinancingSolutionSteps,
    SolicitorSolutionSteps,
		MhlvSolutionSteps,
    [Drawer.name]: Drawer,
    OtherLoanSolutionSteps
},
    mixins: [helperFunctionMixin],
    data() {
        return {
            drawerSolutionScenario: false,
            tables:[],
            layoutProps: {
                showCalculatePage: true,
                showSelectSolutionStepsPage: false,
                showPersonalSolutionStepsPage: false,
                showMortgageSolutionStepsPage: false,
                showInsuranceSolutionStepsPage: false,
                showRefinancingSolutionStepsPage: false,
                showOtherLoanSolutionStepsPage: false,
                showSolicitorSolutionStepsPage: false,
                showMhlvSolutionStepsPage: false
            },
            showsProps: {
                // Property
                showBankSelections: false,
                showPropertySelections: false,
                showUnitSelections: false,
                showSummarySelections: false,
                // Personal Loan
                showPersonalLoanBank: false,
                showPersonalLoanSummary: false,
                showPersonalLoanSelection: false,
                // Mortgage
                showMortgageBank: false,
                showMortgageSummary: false,
                showMortgageSelection: false,

                // Insurance
                showInsuranceCompanies: false,
                showInsuranceSelection: false,
                showInsuranceSummary: false,

                // Refinancing
                showRefinancingBank: false,
                showRefinancingSummary: false,
                showRefinancingSelection: false,

                showOtherLoanSelection: false,
                showOtherLoanSummary: false,
								
                showSolicitorSelection: false,
                showSolicitorSummary: false,

                showMhlvSelection: false,
                showMhlvSummary: false,
            },
        }
    },
    mounted() {
        const eventHandlers = {
            'reset-shows-props': this.resetShowsProps,
            'show-bank-selections': this.selectBankSelections,
            'show-property-selections': this.selectPropertySelections,
            'show-unit-selections': this.selectUnitSelections,
            'show-summary-selections': this.selectSummarySelections,
            'show-personal-loan-bank': this.selectPersonalLoanBank,
            'show-personal-loan-selection': this.selectPersonalLoanSelection,
            'show-personal-loan-summary': this.selectPersonalLoanSummary,
            'show-mortgage-bank': this.selectMortgageBank,
            'show-mortgage-summary': this.selectMortgageSummary,
            'show-mortgage-selection': this.selectMortgageSelections,
            'show-insurance-companies': this.selectInsuranceCompanies,
            'show-insurance-selection': this.selectInsuranceSelection,
            'show-insurance-summary': this.selectInsuranceSummary,
            'show-refinancing-bank': this.selectRefinancingBank,
            'show-refinancing-selection': this.selectRefinancingSelection,
            'show-refinancing-summary': this.selectRefinancingSummary,
            'show-otherloan-selection': this.selectOtherLoanSelection,
            'show-otherloan-summary': this.selectOtherLoanSummary,
            'show-mhlv-selection': this.selectMhlvSelection,
            'show-mhlv-summary': this.selectMhlvSummary,
            'show-solicitor-selection': this.selectSolicitorSelection,
            'show-solicitor-summary': this.selectSolicitorSummary,
        };

        Object.entries(eventHandlers).forEach(([event, handler]) => {
            solutionEventBus.$on(event, handler);
        });
    },
    beforeUnmount() {
        const eventHandlers = {
            'reset-shows-props': this.resetShowsProps,
            'show-bank-selections': this.selectBankSelections,
            'show-property-selections': this.selectPropertySelections,
            'show-unit-selections': this.selectUnitSelections,
            'show-summary-selections': this.selectSummarySelections,
            'show-personal-loan-bank': this.selectPersonalLoanBank,
            'show-personal-loan-selection': this.selectPersonalLoanSelection,
            'show-personal-loan-summary': this.selectPersonalLoanSummary,
            'show-mortgage-bank': this.selectMortgageBank,
            'show-mortgage-summary': this.selectMortgageSummary,
            'show-mortgage-selection': this.selectMortgageSelections,
            'show-insurance-companies': this.selectInsuranceCompanies,
            'show-insurance-selection': this.selectInsuranceSelection,
            'show-insurance-summary': this.selectInsuranceSummary,
            'show-refinancing-bank': this.selectRefinancingBank,
            'show-refinancing-selection': this.selectRefinancingSelection,
            'show-refinancing-summary': this.selectRefinancingSummary,
            'show-otherloan-selection': this.selectOtherLoanSelection,
            'show-otherloan-summary': this.selectOtherLoanSummary,
            'show-mhlv-selection': this.selectMhlvSelection,
            'show-mhlv-summary': this.selectMhlvSummary,
            'show-solicitor-selection': this.selectSolicitorSelection,
            'show-solicitor-summary': this.selectSolicitorSummary,
        };

        Object.entries(eventHandlers).forEach(([event, handler]) => {
            solutionEventBus.$off(event, handler);
        });
    },
    watch:{
        async drawerSolutionScenario(newVal){
            if(newVal === true && this.tables.length === 0){
                this.tables = await this.getLookupTables(['banks', 'loan_types'])
            }
        },
    },
    methods: {
        viewSolutionScenario() {
            this.drawerSolutionScenario = !this.drawerSolutionScenario;
        },
        selectBankSelections() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showSelectSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showBankSelections'
            }
        },
        selectPropertySelections() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showSelectSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showPropertySelections'
            }
            
            const currentQuery = { ...this.$route.query };
            delete currentQuery.product_id;
            delete currentQuery.project_id;
            this.$router.replace({query: currentQuery,},() => {})
        },
        selectUnitSelections() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showSelectSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showUnitSelections'
            }
        },
        selectSummarySelections() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showSelectSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showSummarySelections'
            }
        },
        selectPersonalLoanBank() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showPersonalSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showPersonalLoanBank'
            }
        },
        selectPersonalLoanSelection() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showPersonalSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showPersonalLoanSelection'
            }
        },
        selectPersonalLoanSummary() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showPersonalSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showPersonalLoanSummary'
            }
        },
        selectMortgageBank() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showMortgageSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showMortgageBank'
            }
        },
        selectMortgageSummary() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showMortgageSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showMortgageSummary'
            }
        },
        selectMortgageSelections() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showMortgageSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showMortgageSelection'
            }
        },
        selectInsuranceCompanies() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showInsuranceSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showInsuranceCompanies'
            }
        },
        selectInsuranceSelection() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showInsuranceSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showInsuranceSelection'
            }
        },
        selectInsuranceSummary() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showInsuranceSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showInsuranceSummary'
            }
        },
        selectOtherLoanSelection() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showOtherLoanSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showOtherLoanSelection'
            }
        },
        selectOtherLoanSummary() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showOtherLoanSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showOtherLoanSummary'
            }
        },

        selectMhlvSelection() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showMhlvSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showMhlvSelection'
            }
        },
        selectMhlvSummary() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showMhlvSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showMhlvSummary'
            }
        },
        selectSolicitorSelection() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showSolicitorSolutionStepsPage'
            }
            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showSolicitorSelection'
            }
        },
        selectSolicitorSummary() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showSolicitorSolutionStepsPage'
            }
            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showSolicitorSummary'
            }
        },
        selectRefinancingBank() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showRefinancingSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showRefinancingBank'
            }
        },
        selectRefinancingSelection() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showRefinancingSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showRefinancingSelection'
            }
        },
        selectRefinancingSummary() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showRefinancingSolutionStepsPage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = key === 'showRefinancingSummary'
            }
        },
        resetShowsProps() {
            for (const key in this.layoutProps) {
                this.layoutProps[key] = key === 'showCalculatePage'
            }

            for (const key in this.showsProps) {
                this.showsProps[key] = false
            }

            // remove product id 
            const currentQuery = { ...this.$route.query };
            delete currentQuery.product_id;
            this.$router.replace({query: currentQuery,},() => {})
        }
    }
}
</script>